module.exports = __webpack_public_path__ + "static/media/s_v10_t5.15dcdacc.mp3";